import { logger } from '@/lib/api/logger';
import { mobx } from '@/lib/mobx';

import { SportsbookSocketManager } from '../SportsbookSocketManager';
import { msgTypes } from './msgTypes';

function getType(value) {
  const str = Object.prototype.toString.call(value);
  return str.substring(str.lastIndexOf(' ') + 1, str.lastIndexOf(']')).toLowerCase();
}

function log(message, error) {
  logger.warn(message, {
    error,
  });
}

function postMessageResolver(event) {
  const { data } = event;

  if (typeof data === 'string' && data) {
    let parsedData;

    try {
      parsedData = JSON.parse(data);
    } catch (error) {
      // Silencing to avoid noise from non‑Sportsbook messages, which may be common on some platforms
    }

    try {
      if (parsedData && typeof parsedData === 'object' && !Array.isArray(parsedData)) {
        const { type, data } = parsedData;

        switch (type) {
          case 'themeEditor':
            mobx.ui.setIsThemeEditorMode({
              isEnableThemeEditor: parsedData.isEnable,
              isSendMessage: false,
            });
            break;
          case 'demoBonuses':
            if (!mobx.ui.isDemoFreebetMode) {
              mobx.ui.setIsDemoFreebetMode(true);
              mobx.ui.getDemoProfileBonuses();
            }
            break;
          case 'parentGaps':
            mobx.ui.setParentGaps(data);
            break;
          case 'app':
            switch (data?.status) {
              case 'refresh':
                mobx.auth.setIsReInit(true);
                break;
              case 'destroy':
                SportsbookSocketManager.getInstance().disconnectSocket();
                break;
              case 'logout':
                mobx.auth.logout();
                break;
              default:
                break;
            }
            break;
          case 'openSearch':
            if (data?.isOpen) {
              mobx.ui.setModalMybetsOpen(false);
              mobx.ui.setBetsHistoryOpen(false);
              mobx.ui.setBetSlipOpen(false);

              mobx.search.openSearch();
            } else {
              mobx.search.closeSearch();
            }
            break;
          case 'openMyBets':
            if (data?.isOpen) {
              mobx.ui.setBetSlipOpen(false);
              mobx.search.closeSearch();
            }

            if (mobx.ui.isMobile) {
              mobx.ui.setModalMybetsOpen(Boolean(data?.isOpen));
            } else {
              mobx.ui.setBetsHistoryOpen(Boolean(data?.isOpen));
            }
            break;
          case 'openBetslip':
            if (mobx.ui.isMobile) {
              if (data?.isOpen) {
                mobx.search.closeSearch();
                mobx.ui.setModalMybetsOpen(false);
                mobx.ui.setBetsHistoryOpen(false);
              }

              mobx.ui.setBetSlipOpen(Boolean(data?.isOpen));
            }
            break;
          case 'categorizer':
            mobx.ui.setIsHideCategorizer(Boolean(data?.isHide));
            break;
          case 'gameLaunchUrl':
            mobx.ui.setBannerBetslipUrl(data?.url);
            break;
          default:
            break;
        }
      }
    } catch (error) {
      logger.error('Error when got post message:', { data, error });
    }
  }
}

function sendMsg(type, msgObject) {
  const msgType = msgTypes[type];

  if (!msgType) {
    return;
  }
  const msg = Object.keys(msgType).reduce((obj, key) => {
    const value = msgObject[key];
    if (getType(value) === msgType[key]) {
      if (!obj) {
        obj = { type };
      }
      return { ...obj, [key]: value };
    }
    return obj;
  }, undefined);

  if (!msg) {
    log('Wrong post message value type', {
      type: msgType,
      value: msgObject,
    });
    return;
  }

  window.parent.postMessage(JSON.stringify(msg), '*');
}

function listener(event) {
  postMessageResolver(event);
}

function initPostMessage() {
  if (window.addEventListener) {
    window.addEventListener('message', listener);
  } else {
    window.attachEvent('onmessage', listener);
  }
}

export { initPostMessage, sendMsg };
